export function formatCount(n: number): string {
  if (n >= 10000) {
    const value = n / 10000;
    return `${value.toFixed(value >= 10 ? 0 : 1)}万`;
  }
  return String(n);
}